import type { App } from 'vue'

export default {
  install: function (app: App): void {
    app.config.globalProperties.$spaceURL = function (path: string): string {
      return '#/me/spaces/' + this.$route.params.spaceId + '/' + path
    }

    app.config.globalProperties.$storyURL = function (
      path: string,
      releaseId: unknown,
      pipelineId: unknown,
    ): string | undefined {
      if (
        typeof this.$route.params.pipelineId === 'undefined' &&
        typeof this.$route.params.releaseId === 'undefined' &&
        typeof releaseId === 'undefined'
      ) {
        return this.$spaceURL('stories/0/0/' + path)
      }

      const pipeline = pipelineId || this.$route.params.pipelineId
      const release = releaseId || this.$route.params.releaseId

      return this.$spaceURL(`stories/${pipeline}/${release}/${path}`)
    }
  },
}
